import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import SearchInvoiceCostumers from './components/SearchInvoiceCostumer';

const InvoiceCostumer = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 style={{ marginBottom: 30 }}>Busqueda de Documentos Clientes</h3>
      </Col>
    </Row>
    <Row>
        <SearchInvoiceCostumers />
    </Row>
  </Container>
);

export default InvoiceCostumer;